export default __webpack_public_path__ + "static/media/recycle.39c09428.svg";